import { z } from 'zod';

export const checkStatusSchema = z.enum(['ok', 'degraded', 'fail']);
export type CheckStatus = z.infer<typeof checkStatusSchema>;

export const checkResultSchema = z.object({
  status: checkStatusSchema,
  latencyMs: z.number().nonnegative().optional(),
  message: z.string().optional(),
  details: z.record(z.string(), z.union([z.number(), z.string(), z.boolean(), z.null()])).optional(),
});
export type CheckResult = z.infer<typeof checkResultSchema>;

export const readinessResponseSchema = z.object({
  status: checkStatusSchema,
  checkedAt: z.iso.datetime(),
  version: z.string(),
  checks: z.object({
    database: checkResultSchema,
    redis: checkResultSchema,
    queue: checkResultSchema,
  }),
});
export type ReadinessResponse = z.infer<typeof readinessResponseSchema>;

export const livenessResponseSchema = z.object({ status: z.literal('ok') });
export type LivenessResponse = z.infer<typeof livenessResponseSchema>;

/** Итоговый статус: худший из статусов проверок. */
export function combineStatuses(statuses: readonly CheckStatus[]): CheckStatus {
  if (statuses.includes('fail')) return 'fail';
  if (statuses.includes('degraded')) return 'degraded';
  return 'ok';
}
